import { LegacyProductBoundary } from "../../product-access/ProductAccessContext";
import React from 'react';
import { SUPPORTED_WEB_LANGUAGES, normalizeWebLanguage } from '../../webLanguages';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { setZooType } from '../../store/actions/zoo.actions';

import Header from './Header'
import Sidebar from './Sidebar'
import Offsidebar from './Offsidebar'
import Footer from './Footer'
import DocDrawer from '../Views/HelpCenter/components/DocDrawer'
import { onDemoLocaleChange, onDemoModeChange } from '../../anonymization'


class Base extends React.Component {

    state = { demoEpoch: 0 }

    componentDidMount() {
        // Restaurer la langue de l'utilisateur depuis localStorage au refresh
        this.restoreUserLanguage();
        this.refreshZooType();
        // Abonnement APRÈS la restauration : le changeLanguage du boot ne doit
        // pas remonter des vues qui viennent tout juste de se monter.
        this.unsubscribeDemoLocale = onDemoLocaleChange(this.remountViews);
        // Basculer le mode démo (ou ses photos factices) remonte aussi les vues :
        // leurs données sont relues à travers le proxy d'anonymisation.
        this.unsubscribeDemoMode = onDemoModeChange(this.remountViews);
    }

    componentWillUnmount() {
        if (this.unsubscribeDemoLocale) this.unsubscribeDemoLocale();
        if (this.unsubscribeDemoMode) this.unsubscribeDemoMode();
    }

    // La catégorie du parc pilote le vocabulaire (Laboratoire → Établissement,
    // Unité, Hébergement…). Relue à chaque chargement : un changement de parc
    // par le staff la remet à null, et un admin peut la modifier entre-temps.
    refreshZooType = async () => {
        try {
            // Import différé : tools/conf ↔ usersDatabaseConnector forment un cycle
            // qu'un import statique depuis la mise en page évalue dans le mauvais ordre.
            const { getZooIdAndType } = await import('../../tools/conf');
            const { zooId, zooType } = await getZooIdAndType();
            if (zooId && zooType !== this.props.zooType) this.props.setZooType(zooType);
        } catch (_error) {
            // Sans parc lisible, le vocabulaire courant est conservé.
        }
    }

    remountViews = () => {
        this.setState((prev) => ({ demoEpoch: prev.demoEpoch + 1 }));
    }

    restoreUserLanguage = () => {
        try {
            // Langues supportées sur le web


            // 1. Vérifier la préférence web locale (prioritaire)
            const webPref = localStorage.getItem('webLanguagePreference');
            if (webPref && SUPPORTED_WEB_LANGUAGES.includes(webPref)) {
                if (this.props.i18n && this.props.i18n.language !== webPref) {
                    this.props.i18n.changeLanguage(webPref);
                }
                return;
            }

            // 2. Sinon vérifier webLanguagePreference dans userData (préservé lors du changement de zoo)
            const userDataStr = localStorage.getItem('userData');
            if (userDataStr) {
                const userData = JSON.parse(userDataStr);
                if (userData?.webLanguagePreference && SUPPORTED_WEB_LANGUAGES.includes(userData.webLanguagePreference)) {
                    if (this.props.i18n && this.props.i18n.language !== userData.webLanguagePreference) {
                        this.props.i18n.changeLanguage(userData.webLanguagePreference);
                    }
                    return;
                }

                // 3. Sinon utiliser la langue du profil avec fallback vers EN si non supportée
                const userLanguage = userData?.userMainLanguage;
                if (userLanguage && this.props.i18n) {
                    const finalLanguage = normalizeWebLanguage(userLanguage);
                    if (this.props.i18n.language !== finalLanguage) {
                        this.props.i18n.changeLanguage(finalLanguage);
                    }
                }
            }
        } catch (error) {
            console.error('Error restoring user language:', error);
        }
    }

    render() {
        return (
            <div className="wrapper">
                <Header />

                <Sidebar />

                <Offsidebar />

                <DocDrawer />

                {/* Un changement de mode démo ou de langue remonte les vues : les
                    noms fictifs ne sont recalculés qu'au refetch des données. */}
                <section className="section-container" key={this.state.demoEpoch}>
                    <LegacyProductBoundary>{this.props.children}</LegacyProductBoundary>
                </section>

                <Footer />
            </div>
        )

    }
}

const mapStateToProps = (state) => ({ zooType: state.zoo?.zooType ?? null });
const mapDispatchToProps = (dispatch) => ({ setZooType: (value) => dispatch(setZooType(value)) });

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Base));

